// index.js
import en_us from '@/locale/en-US'
import su from './su'

export const languages = {
  en_us: en_us,
  sv: su,
}
